import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Identity } from 'src/app/identity/identity.model';
import { IdentityService } from 'src/app/identity/identity.service';
import {Esito, GenericResponse} from 'src/app/api-interfaces';
import { Observable } from 'rxjs';
import { FuncsService } from 'src/app/shared/funcs.service';
import { LogService } from 'src/app/shared/log.service';
import { TimerService } from 'src/app/shared/timer/timer.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/auth.service';
import { ValidateControlCode } from 'src/app/shared/control-code.validator';

@Component({
  selector: 'app-activate-identity',
  templateUrl: './activate-identity.component.html',
  styleUrls: ['./activate-identity.component.sass']
})
export class ActivateIdentityComponent implements OnInit {
  @Input() identity: Identity;

  private tplModal?: NzModalRef;
  isSpinning = false;
  validateForm!: UntypedFormGroup;
  eidupValidateForm: UntypedFormGroup;
  otpCode: string;
  isVisible = true;
  tokenVisible = false;
  controlCodeVisible = false;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private modalService: NzModalService,
    private identityService: IdentityService,
    private logger: LogService,
    public timerService: TimerService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      otpCode: [null, [Validators.required]],
    });

    this.eidupValidateForm = this.fb.group({
      token: [null, [Validators.required]],
      controlCode: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern('^[0-9]{3}'), ValidateControlCode]],
      otpCode: [null, [Validators.required]],
    });

  }

  onOpenActivationModal(modal: TemplateRef<{}>, modalEidup: TemplateRef<{}>, modalFooter: TemplateRef<{}>, modalEidupFooter: TemplateRef<{}>): void {
    this.validateForm.reset();
    const identities = this.authService.getCurrentUser().identities;
    const currentUser = this.authService.getCurrentUser();
    for (const identity of identities) {
      const castedIdentity = new Identity(identity);
      if (castedIdentity.isEmployee() && currentUser.eidup_request) {
        this.tplModal = this.modalService.create({
          nzTitle: $localize`:Identity.ActivateIdentity.ModalEidupTitle|modal title in activate identity page@@Identity.ActivateIdentity.ModalEidupTitle:Attivazione SPID`,
          nzContent: modalEidup,
          nzFooter: modalEidupFooter, });
        return;
      }
    }
    this.tplModal = this.modalService.create({
      nzTitle: $localize`:Identity.ActivateIdentity.ModalTitle|modal title in activate identity page@@Identity.ActivateIdentity.ModalTitle:Attivazione SPID`,
      nzContent: modal,
      nzFooter: modalFooter,
    });

    if (this.timerService.isTimerSendOTPSetted(true)) {
      this.identityService.sendOtp();
    }
  }

  onActivateIdentity(): void {
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    this.isSpinning = true;
    this.isVisible = false;
    this.identityService.activateIdentity(this.identity.pk.toString(), this.validateForm.value.otpCode)
      .subscribe(
        (response: GenericResponse) => {
          if (response.esito === Esito.Ok)  {
            this.logger.log('Response OK');
            if (environment.resetTimerWhenSubmit) {
              this.timerService.resetTimerSendOTP();
            }
            this.tplModal.close();
          }
          else {
            this.isVisible = true;
          }
        },
        (err: Observable<never>) => { this.isSpinning = false; this.isVisible = true; },
        () => { this.isSpinning = false; },
      );
  }

  onActivateEidupIdentity(): void {
    for (const i in this.eidupValidateForm.controls) {
      if (this.eidupValidateForm.controls[i].invalid) {
        return;
      }
    }
    this.isVisible = false;
    this.isSpinning = true;
    const token = this.eidupValidateForm.get('token').value;
    const controlCode = this.eidupValidateForm.get('controlCode').value;
    const otp = this.eidupValidateForm.get('otpCode').value;
    this.identityService.enrollRequest(token, controlCode, otp).subscribe(
      (response: GenericResponse) => {
        if (response.esito === Esito.Ok) {
          this.tplModal.close();
          this.isSpinning = false;
        } else {
          this.isVisible = true;
        }
    }, (error: any) => {
      this.isSpinning = false;
      this.isVisible = true;
    });
  }

  requestNewOTP(): void {
    this.logger.log('Requesting new otp');

    this.isSpinning = true;
    this.timerService.setTimerOTP();
    this.identityService.requestOtp()
      .subscribe(
        (response: GenericResponse) => {
          if (response.esito === Esito.Ok) {
            this.logger.log('Response OK');
            this.validateForm.reset();
            this.identity.status = 'ISSUED';
            this.identityService.setCurrentIdentity(this.identity);
          }
        },
        (err: Observable<never>) => { this.isSpinning = false; },
        () => { this.isSpinning = false; },
      );
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  activateSpin(value: boolean): void {
    this.isSpinning = value;
  }

}
